import { useState } from 'react';
import { FileCode, PackageOpen, ClipboardCopy, Camera, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { exportHtml, exportPwaZip, copySource } from '../../lib/exporter';
import { PublishButton } from '../PublishDialog';

export default function ExportPanel({ game, settings, onCapture, updateGame }) {
  const [busy, setBusy] = useState(null);
  const go = async (id, fn, msg) => {
    setBusy(id);
    try { await fn(); toast.success(msg); } catch (e) { toast.error(e.message || 'Export fallito'); }
    setBusy(null);
  };
  const items = [
    { id: 'html', icon: FileCode, t: 'HTML monolitico', d: 'Un file con grafica, suoni, motore e controller touch. Doppio clic e si gioca, offline.', run: () => exportHtml(game, settings), msg: 'File HTML scaricato' },
    { id: 'zip', icon: PackageOpen, t: 'PWA autonoma (ZIP)', d: 'index.html + manifest.json + sw.js + icone: installabile sulla Home degli amici.', run: () => exportPwaZip(game, settings), msg: 'Pacchetto PWA scaricato' },
    { id: 'js', icon: ClipboardCopy, t: 'Codice sorgente pulito', d: 'Copia negli appunti solo lo script JavaScript.', run: () => copySource(game), msg: 'JavaScript copiato negli appunti' },
  ];
  return (
    <div data-testid="export-panel" className="space-y-4">
      <div className="t-label">Distribuzione</div>
      <PublishButton game={game} updateGame={updateGame} />
      <div className="t-label pt-2">Screenshot Studio</div>
      <div className="relative rounded-xl overflow-hidden border border-white/10 aspect-video">
        {game.cover && <img data-testid="export-cover" src={game.cover} alt="copertina" className="h-full w-full object-cover" />}
        <button data-testid="export-capture-btn" onClick={() => go('cap', onCapture, 'Copertina aggiornata')} className="absolute bottom-2 right-2 flex items-center gap-1.5 rounded-full bg-black/70 backdrop-blur px-3 py-1.5 text-[10px] font-bold text-cyan-200 border border-cyan-400/40 hover:bg-cyan-500/20 transition-colors">
          <Camera className="h-3.5 w-3.5" />CATTURA LOCANDINA
        </button>
      </div>
      <div className="t-label pt-2">Export Engine</div>
      {items.map((it) => (
        <button key={it.id} data-testid={`export-${it.id}-btn`} disabled={!!busy} onClick={() => go(it.id, it.run, it.msg)}
          className="w-full text-left rounded-xl border border-violet-500/25 p-3 flex gap-3 hover:bg-violet-500/10 hover:border-violet-400/50 transition-colors disabled:opacity-50">
          <div className="h-10 w-10 shrink-0 rounded-lg bg-gradient-to-br from-violet-600/40 to-cyan-600/30 flex items-center justify-center">
            {busy === it.id ? <Loader2 className="h-5 w-5 animate-spin" /> : <it.icon className="h-5 w-5 text-cyan-200" />}
          </div>
          <div><div className="text-xs font-bold text-slate-100">{it.t}</div><div className="text-[11px] text-slate-400 t-chat mt-0.5">{it.d}</div></div>
        </button>
      ))}
    </div>
  );
}
